import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { VM_Colors } from "../../Styles/VMStyles";
import VMEDEventInfo from "./VMEDEventInfo";
import { isEmpty } from "../../Util/UtilHelper";

function VMEDEventTabs({ events = [], customer, readOnly = false, hasInvoice = false }) {
  const [activeTab, setActiveTab] = useState(0);

  const validEvents = events.filter((event) => !isEmpty(event));

  useEffect(() => {
    if (activeTab >= validEvents.length) {
      setActiveTab(0);
    }
  }, [activeTab, validEvents.length]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const selectedEvent = validEvents[activeTab]; // Get selected event

  return (
    <Box sx={{ flexGrow: 1 ,p:1,mt:1}}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="standard"
        TabIndicatorProps={{ style: { height: 3 } }}
        sx={{
          minHeight: "auto",
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
            gap: 1,
          },
        }}
      >
        {validEvents.map((_, index) => {
          const isSelected = activeTab === index;
          return (
            <Tab
              key={index}
              label={`Event ${index + 1}`}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                borderRadius: 1,
                width: 100,
                minWidth: "auto",
                padding: "6px 12px",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease-in-out",
                color: isSelected ? VM_Colors.white : VM_Colors.black,
                backgroundColor: isSelected
                  ? VM_Colors.primary
                  : VM_Colors.white1,
                "&:hover": {
                  backgroundColor: isSelected
                    ? VM_Colors.primary
                    : VM_Colors.white2,
                  color: isSelected ? VM_Colors.white : VM_Colors.black,
                },
                "&.Mui-selected": {
                  color: VM_Colors.white,
                },
              }}
            />
          );
        })}
      </Tabs>

      {
        isEmpty(selectedEvent)
        ? null
        : <VMEDEventInfo eventData={selectedEvent} customer={customer} readOnly={readOnly} hasInvoice={hasInvoice} />
      }
     
    </Box>
  );
}

export default VMEDEventTabs;
